import React from "react";
import { Provider } from "urql";
import type { Client } from "urql";
import * as Scrivito from "scrivito";
import { useCreateUrqlClient } from "api/urqlClient";

type ClientContextType = {
  client: Client;
  resetUrqlClient: () => void;
};

const ClientContext = React.createContext<ClientContextType>({
  client: {} as Client,
  resetUrqlClient: () => {},
});

type UrqlProviderProps = { children: React.ReactNode };

export const UrqlProvider = Scrivito.connect(
  ({ children }: UrqlProviderProps) => {
    const result = useCreateUrqlClient();
    const [clientObj, setClientObj] = React.useState(result);

    return (
      <ClientContext.Provider
        value={{
          resetUrqlClient: () => {
            setClientObj(result);
          },
          client: clientObj.client,
        }}
      >
        <Provider value={clientObj.client}>{children}</Provider>
      </ClientContext.Provider>
    );
  },
);

export const useUrqlContext = (): ClientContextType =>
  React.useContext(ClientContext);
